import React from 'react'
import AddFilter from '../../../../Components/Filters/AddFilter'

export default function AddRegionFilter() {
  return (
    <AddFilter department="region"/>
  )
}
